import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonNav, IonicModule } from '@ionic/angular';

import { PaymentSuccessPage } from './payment-success.page';
import { MasterHeaderModule } from '../../master/master-header/master-header.module';

const routes: Routes = [
  {
    path: '',
    component: PaymentSuccessPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    MasterHeaderModule
  ],
  declarations: [PaymentSuccessPage],
  providers: [IonNav],
})
export class PaymentSuccessPageModule {}
